import { attr } from 'redux-orm'
import Base from './Base'

class BillingPlan extends Base {
  static get fields () {
    return {
      id: attr(),
      name: attr(),
      kind: attr(),
      params: attr(),
      active: attr()
    }
  }
}

BillingPlan.modelName = 'billingPlan'

export default BillingPlan
